export const computeUtilityTotalUsageKwh = (utility) => {
  if (!utility || typeof utility !== 'object') return null;

  const direct =
    utility.totalUsage ??
    utility.total_usage ??
    utility.yearly_usage ??
    utility.yearlyUsage;
  if (direct !== undefined && direct !== null && direct !== '') {
    const number = Number(direct);
    return Number.isFinite(number) ? number : null;
  }

  const usage = utility.usage;
  if (Array.isArray(usage) && usage.length > 0) {
    const sum = usage.reduce((total, value) => total + (Number(value) || 0), 0);
    return Number.isFinite(sum) ? sum : null;
  }

  const average = utility.average_usage ?? utility.averageUsage;
  if (average !== undefined && average !== null && average !== '') {
    const number = Number(average);
    return Number.isFinite(number) ? number * 12 : null;
  }

  return null;
};

export const parseAnnualUsageKwhFromSummaryRaw = (value) => {
  if (value === undefined || value === null || value === '') return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) && value > 0 ? value : null;
  }
  const match = String(value)
    .trim()
    .match(/[\d][\d,]*(?:\.[\d]+)?/);
  if (!match) return null;
  const number = Number(match[0].replace(/,/g, ''));
  return Number.isFinite(number) && number > 0 ? number : null;
};

/** @param {unknown} utility @param {Record<string, unknown> | null} summary */
export const resolveAnnualUsageKwhForOffset = (utility, summary = null) => {
  const fromUtility = computeUtilityTotalUsageKwh(utility);
  if (fromUtility !== null && Number.isFinite(fromUtility) && fromUtility > 0) {
    return fromUtility;
  }
  return parseAnnualUsageKwhFromSummaryRaw(
    summary?.annual_usage ?? summary?.annualUsage ?? summary?.annual_usage_kwh
  );
};
